"use client"

import * as React from "react"
import * as CheckboxPrimitive from "@radix-ui/react-checkbox"
import { CheckIcon } from "lucide-react"

import { cn } from "@/lib/utils"

/**
 * Pure-CSS Checkbox — previously wrapped in nested `motion.div` for a
 * hover/tap micro-scale and a check-mark scale-in. We replicate the feel with
 * CSS transforms (still GPU-accelerated) and avoid framer-motion entirely.
 *
 * Honors `prefers-reduced-motion` via `motion-safe:`.
 */
function Checkbox({
  className,
  ...props
}: React.ComponentProps<typeof CheckboxPrimitive.Root>) {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      className={cn(
        "peer border-input dark:bg-input/30 data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground dark:data-[state=checked]:bg-primary data-[state=checked]:border-primary focus-visible:border-ring aria-invalid:border-destructive size-4 shrink-0 rounded-[4px] border shadow-xs transition-shadow outline-none disabled:cursor-not-allowed disabled:opacity-50",
        "motion-safe:transition-transform motion-safe:duration-150 motion-safe:hover:scale-110 motion-safe:active:scale-90",
        className
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className="grid place-content-center text-current motion-safe:animate-in motion-safe:zoom-in-50 motion-safe:duration-150"
      >
        <CheckIcon className="size-3.5" />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  )
}

export { Checkbox }
